/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    NoteFinderUserConfirmationMutation$variables
} from "mutation/__generated__/NoteFinderUserConfirmationMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation NoteFinderUserConfirmationMutation($input: MusicParseStepNoteFinderUserConfirmationInput!) {
        music_parse_step_note_finder_user_confirmation(input: $input) {
           parse_step {
                id
                status
           }
        }
    }
`;

export default function NoteFinderUserConfirmation(parseStepId: string, pageId: string) {
    const variables: NoteFinderUserConfirmationMutation$variables = {
        input: {
            parse_step_id: parseStepId,
            page_id: pageId
        }
    };
    return perform(mutation, variables);
}